/*
 * Copyright (c) 2023 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import { JSONable } from '@irian-ro/abstract-resource';
import { PointDtoModel } from '@well/address-management-domain-model';

export class ETransportAddressDTO extends JSONable {

  state: string | null = null;
  countyCode: string | null = null;
  city: string | null = null;
  streetName: string | null = null;
  postalCode: string | null = null;
  streetNumber: string | null = null;
  block: string | null = null;
  building: string | null = null;
  floor: string | null = null;
  apartment: string | null = null
  details: string | null = null;
  pointDTO: PointDtoModel | null = null;

}
